/*********************
End of Phrase Rule
*********************/
import Rule from './Rule';
import { ruleInputTypes, ruleTypes } from '../../constants';

// Rule applies logic based on whether we're intervening
// at the end of a phrase
export default class EndOfPhraseRule extends Rule {
  constructor(logic) {
    super([ruleInputTypes.endOfPhrase],logic);
    this.ruleType = ruleTypes.END_OF_PHRASE;
  }
}